const state = {
    errors: []
};

export default state;